import React, { useState, useEffect } from "react";
import "./Change_Nickname_modal.css";
import { Modal, Button, Form } from "react-bootstrap";

function Change_Nickname_modal({ ...props }) {
  return (
    <>
      <Modal
        {...props}
        centered
        size="sm"
        backdrop="static"
        className="Change_Nickname_modal Common_modal"
        scrollable
      >
        <Modal.Body>
          <div className="upi_container ">
            <div className="modal_header ">Change Nickname</div>
            <div className="box_holder login-page">
            <div className="form-group field_holder">
              <Form.Label>
                <img
                  src="/assets/images/icons/user.png"
                  alt="icon"
                  className="login_lable_icons"
                />
                Nickname
              </Form.Label>

              <Form.Control type="text" placeholder="MEMBERNNG6QJIT" />
            </div>

            <div className="btn_holder mt-5">
              <Button className="btn_register_bg" onClick={props.onHide}>
                Close
              </Button>
            </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Change_Nickname_modal;
